"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSyncedState = exports.updateSpecialtyState = exports.updateSearchField = exports.fireSearch = exports.fireFeedback = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _constants = require("./constants");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var http = require('lc-http');
var updateSearchField = function updateSearchField(field, value) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch, getState) {
      var _getState, search, specialty, location, name;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), search = _getState.search;
            specialty = field === 'specialty' ? value : search.specialty;
            location = field === 'location' ? value.trim() : search.location;
            name = field === 'name' ? value.trim() : search.name;
            return _context.abrupt("return", dispatch({
              type: _constants.UPDATE_SEARCH_STATE,
              payload: {
                specialty: specialty,
                location: location,
                name: name
              }
            }));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
exports.updateSearchField = updateSearchField;
var updateSpecialtyState = function updateSpecialtyState() {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch, getState) {
      var _getState2, search, specialtyState;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _getState2 = getState(), search = _getState2.search;
            specialtyState = !search.specialtyOpen;
            return _context2.abrupt("return", dispatch({
              type: _constants.UPDATE_SPECIALTY_STATE,
              payload: {
                specialtyOpen: specialtyState
              }
            }));
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
exports.updateSpecialtyState = updateSpecialtyState;
var updateSyncedState = function updateSyncedState() {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch, getState) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", dispatch({
              type: _constants.UPDATE_SYNCED_STATE,
              payload: {
                stateSynced: true
              }
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
exports.updateSyncedState = updateSyncedState;
var fireFeedback = function fireFeedback() {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch, getState) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", dispatch({
              type: _constants.UPDATE_FEEDBACK_STATE,
              payload: {
                feedback: true
              }
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
exports.fireFeedback = fireFeedback;
var fireSearch = function fireSearch(event) {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch, getState) {
      var _getState3, siteInfo, search, table, specialty, location, name, providerRecords, recordsMap, typeOfResult, records, totalResultsFromExactSearch, pageNumber, searchQuery, postACHUrl, eventPayLoad;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _getState3 = getState(), siteInfo = _getState3.siteInfo, search = _getState3.search, table = _getState3.table;
            specialty = search.specialty;
            location = search.location;
            name = search.name;
            providerRecords = [];
            recordsMap = {};
            typeOfResult = '', records = table.records;
            pageNumber = event === _constants.MORE_COMPLETE ? table.pageNumber + 1 : event === _constants.COMPLETE ? 0 : table.pageNumber;
            searchQuery = {
              specialty: specialty,
              location: location,
              name: name,
              pageNumber: pageNumber
            }; // event can be 'COMPLETE', 'MORE_COMPLETE', 'PENDING', 'MORE_PENDING' 'INITIAL'
            if (!(event === _constants.COMPLETE || event === _constants.MORE_COMPLETE)) {
              _context5.next = 28;
              break;
            }
            postACHUrl = siteInfo.realm === _constants.LCYTS ? '/search/provider' : '/patientsolutions/app/search/provider';
            _context5.prev = 11;
            _context5.next = 14;
            return http.post(postACHUrl, searchQuery, {
              timeout: 10000
            });
          case 14:
            providerRecords = _context5.sent;
            records = event === _constants.MORE_COMPLETE ? records.concat(providerRecords.data.results) : providerRecords.data.results;
            recordsMap = event === _constants.MORE_COMPLETE ? _objectSpread(_objectSpread({}, recordsMap), providerRecords.data.resultsMap) : providerRecords.data.resultsMap;
            typeOfResult = providerRecords.data.matchType;
            totalResultsFromExactSearch = providerRecords.data.totalResults ? providerRecords.data.totalResults : 0;
            eventPayLoad = {
              PF_ELASTIC_RESULT_TYPE: typeOfResult,
              PF_ELASTIC_RESULT_LENGTH: records.length
            };
            (0, _constants.trackEventWithHeap)(_constants.PF_PROVIDER_ELASTIC_SEARCH_EVENT, eventPayLoad);
            _context5.next = 28;
            break;
          case 23:
            _context5.prev = 23;
            _context5.t0 = _context5["catch"](11);
            console.log('call to provider search failed', _context5.t0);
            typeOfResult = 'error';
            records = [];
          case 28:
            return _context5.abrupt("return", dispatch({
              type: _constants.UPDATE_TABLE_STATE,
              payload: {
                records: records,
                recordsMap: recordsMap,
                resultType: typeOfResult,
                searchQuery: searchQuery,
                feedback: false,
                totalResultsFromExactSearch: totalResultsFromExactSearch,
                pageNumber: pageNumber,
                request: event
              }
            }));
          case 29:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[11, 23]]);
    }));
    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
};
exports.fireSearch = fireSearch;
